module.exports = __webpack_public_path__ + "img/no_order.ae8cf15b.png";